import React from 'react';
import Collapse, { Panel } from 'rc-collapse';
import mapValues from 'lodash/mapValues';
import {
  LOCALIZATION_LANGUAGES,
  FILLED_BACKGROUND,
  EMPTY_BACKGROUND,
} from './localizationLanguages';
import { TargetNode } from '../../models/TargetNode';

// The green/grey marker used to be applied by MUTATING the created element's
// props (`item.props.children[0].props.style.background = …`), which React does
// not support — element props are meant to be read-only. It is decided before
// the element is built now, with the same result.

// The localization editors are <textarea>s, not <input>s. Panels that forward a
// handler down here must use this type — several declared an input-event handler
// and only tsc noticed the mismatch.
export type LocalizationChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => void;

interface LocalizationPanelProps {
  node: TargetNode;
  // Which slot of each language's question array this panel edits: 0 = the
  // question, 1/2/5 = the positive/negative/neutral follow-ups, 3 = the
  // contact-form title, 4 = the thank-you text.
  localizationIndex: number;
  localizationChanged: LocalizationChangeHandler;
  header: React.ReactNode;
}

const LocalizationPanel = ({
  node, localizationIndex, localizationChanged, header,
}: LocalizationPanelProps) => {
  // One value per language: that language's entry at this index.
  const values = mapValues(node.question || {}, (v: string[]) => v[localizationIndex]);

  return (
    <Collapse accordion={true}>
      <Panel header={header}>
        {Object.entries(LOCALIZATION_LANGUAGES).map(([code, name]) => {
          const value = values[code] || '';
          return (
            <div key={code}>
              <input type="text" className="pure-u-4-24"
                style={{
                  minHeight: "24px",
                  background: value ? FILLED_BACKGROUND : EMPTY_BACKGROUND,
                  color: "rgba(255, 255, 255, 1)",
                }}
                value={`${code.toUpperCase()} ${name}`}
                name={`localization_${code}`}
                readOnly={true} />
              <textarea className="pure-u-20-24"
                style={{ minHeight: "24px", resize: "vertical" }}
                value={value}
                onChange={localizationChanged}
                name={`localizationEdit_${code}`}
                data-redisid={code} />
            </div>
          );
        })}
      </Panel>
    </Collapse>
  );
};

export default React.memo(LocalizationPanel);
